import { render, staticRenderFns } from "./CursoEditar.vue?vue&type=template&id=0d945be5&"
import script from "./CursoEditar.vue?vue&type=script&lang=js&"
export * from "./CursoEditar.vue?vue&type=script&lang=js&"
import style0 from "./CursoEditar.vue?vue&type=style&index=0&id=0d945be5&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports